var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"skip-button",on:{"click":function($event){$event.stopPropagation();return _vm.handleSkipClick($event)}}},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.text)),_c('i',{staticClass:"fas fa-caret-right"})])])}
var staticRenderFns = []

export { render, staticRenderFns }